import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const CREATE_ROLE_REQUEST = "CREATE_ROLE_REQUEST";
export const CREATE_ROLE_SUCCESS = "CREATE_ROLE_SUCCESS";
export const CREATE_ROLE_FAILURE = "CREATE_ROLE_FAILURE";

export const FETCH_ROLES_REQUEST = "FETCH_ROLES_REQUEST";
export const FETCH_ROLES_SUCCESS = "FETCH_ROLES_SUCCESS";
export const FETCH_ROLES_FAILURE = "FETCH_ROLES_FAILURE";

export const createRole = (data) => async (dispatch) => {
  dispatch({ type: CREATE_ROLE_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(`${BASE_URL}/v1/api/create-role`, data, {
      headers: { authorization: token },
    });

    if (response.data.meta.status) {
      dispatch({ type: CREATE_ROLE_SUCCESS });
      toast.success(response.data.meta.message || "Role created successfully");
      return response.data;
    } else {
      dispatch({ type: CREATE_ROLE_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: CREATE_ROLE_FAILURE });
    toast.error(error.response?.data?.meta?.message || "Failed to create role");
    throw error;
  }
};

export const fetchRoles = () => async (dispatch) => {
  dispatch({ type: FETCH_ROLES_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/get-role-list`, {
      headers: { authorization: token },
    });

    if (response.data.meta.status) {
      dispatch({ type: FETCH_ROLES_SUCCESS, payload: response.data.data });
      return response.data;
    } else {
      dispatch({ type: FETCH_ROLES_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: FETCH_ROLES_FAILURE });
    toast.error(error.response?.data?.meta?.message || "Failed to fetch roles");
    throw error;
  }
};
